module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-18-a2c2915c20fb7a2642b1947b734d6ea8.svg";